import React from 'react';
import { SendFundsSchemaInputs } from '@shared/zod-schemas/frontend';
import { Loader2, SearchX } from 'lucide-react';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { useGetUsernames } from '@/hooks/auth/useGetUsernames';
import { Button } from '@/components/ui/button';
import classNames from '@/lib/misc/classNames';
import { ScrollArea } from '@/components/ui/scroll-area';
const UserSearchResults = ({
  value,
  handleOnSelectUser
}: {
  value: SendFundsSchemaInputs['sendTo'];
  handleOnSelectUser: (_: SendFundsSchemaInputs['sendTo']) => void;
}) => {
  const {
    data: getUsernamesData,
    isLoading: isLoadingGetUsernamesData,
    error: ErrorGetUsernamesData
  } = useGetUsernames({
    phrase: value
  });
  return <div data-sentry-component="UserSearchResults" data-sentry-source-file="userSearchResults.tsx">
      {value.length > 0 && Boolean(isLoadingGetUsernamesData || ErrorGetUsernamesData || getUsernamesData) && <ScrollArea className='h-[300px] rounded-xl border-[1px] w-full genius-shadow bg-genius-indigo s'>
            <div className='overflow-hidden'>
              {isLoadingGetUsernamesData && <Loader2 className='animate-spin w-4 h-4 mx-auto my-4' />}
              {ErrorGetUsernamesData && <p>Error getting usernames</p>}
              {getUsernamesData && <div className='grid gap-2'>
                  {getUsernamesData.length > 0 ? <>
                      {getUsernamesData?.filter((x, idx) => {
              const index = getUsernamesData?.findIndex(y => y.username === x.username);
              return index === idx;
            }).map(user => <GeniusUserPane key={user.id} user={user} handleOnSelectUser={handleOnSelectUser} />)}
                    </> : <div className='text-genius-cream/50 flex gap-2 items-center p-4'>
                      <SearchX className='w-4 h-4' />
                      <p>No username found</p>
                    </div>}
                </div>}
            </div>
          </ScrollArea>}
    </div>;
};
export default UserSearchResults;
export function GeniusUserPane({
  user,
  handleOnSelectUser,
  className
}: {
  user: any;
  className?: string;
  handleOnSelectUser?: (_: string) => void;
}) {
  return <div key={user.id} className={classNames('flex justify-between items-center h-[80px] px-6 cursor-pointer z-[100] not-hovered', className)} data-sentry-component="GeniusUserPane" data-sentry-source-file="userSearchResults.tsx">
      <>
        <div className={`flex gap-6 items-center`}>
          <ImageWithFallback alt='user-avatar' src={`/static/genie/${user.pfp}`} width={33} height={33} className='rounded-md' data-sentry-element="ImageWithFallback" data-sentry-source-file="userSearchResults.tsx" />
          <div className='grid justify-items-start'>
            <div className='flex gap-x-2  gap-y-0 text-[16px] flex-wrap'>
              <p>{user.first_name}</p>
            </div>
            <p className='text-[12px] opacity-50'>{user.username}</p>
          </div>
        </div>
        {handleOnSelectUser && <Button onClick={() => {
        handleOnSelectUser && handleOnSelectUser(user.username);
      }} variant='blue' type='button' className='w-[71px] h-[36px] text-[12px]'>
            Send
          </Button>}
      </>
    </div>;
}